export function formatDate(date){
  const d= new Date(date);
  const m = d.getMonth()+1
  const dd = d.getDate()
  return `${d.getFullYear()}年${m<10?`0${m}`:m}月${dd<10?`0${dd}`:dd}日`
}

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function numberWithCommas(x) {
return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export const getImageFileAspectRatio = (file) => {
  return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
          const aspectRatio = img.width / img.height;
          resolve(aspectRatio);
      };
      img.onerror = (error) => {
          reject(error);
      };
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  });
}